/* eslint-disable */
import { en, fi, sv } from "@messageformat/runtime/lib/cardinals";
import { plural } from "@messageformat/runtime";
export default {
  en: {
    login: {
      body: () => "Your feedback can be processed faster if you log in before submitting feedback.",
      link: () => "Log into the service and report a technical problem"
    },
    info: {
      title: () => "Describe the problem as accurately as possible",
      list: {
        item1: () => "What were you doing when the problem occurred? What did not work? Did you get an error message? If yes, what did it say?",
        item2: () => "Had you logged in with OP’s or some other bank’s user ID? Which bank?",
        item3: () => "State the date and time of the occurrence of the problem and the device you used (computer, tablet, smartphone).",
        item4: {
          anonymous: () => "Take a screenshot of the problem if possible. We may ask you to send it to us later. For this, please provide your contact details.",
          loggedIn: () => "Take a screenshot of the problem if possible. We may ask you to send it to us later."
        }
      }
    },
    feedback: {
      header: () => "Report of a technical problem",
      body: () => "All fields are required, unless indicated as optional.",
      form: {
        optional: () => "(optional)",
        target: {
          label: () => "Which services were you using?",
          option: {
            "default": () => "- Select -",
            banking: () => "Banking",
            insurance: () => "Insurance",
            other: () => "Other services"
          },
          error: {
            empty: () => "Select which services you were using."
          }
        },
        subject: {
          label: () => "Where did the problem occur?",
          option: {
            "default": () => "- Select -",
            report_issue_web_service: () => "On the op.fi online service",
            report_issue_op_mobile: () => "On OP-mobile",
            report_issue_op_business_mobile: () => "On OP Business mobile"
          },
          error: {
            empty: () => "Select where the problem occurred."
          }
        },
        text: {
          label: () => "Problem description",
          hint: () => "Describe your problem as accurately as possible. The information needed to investigate the problem is listed at the top of this page.",
          error: {
            empty: () => "Describe the problem."
          }
        },
        contactCustomer: {
          form: {
            label: () => "Contact Information"
          },
          label: () => "I want to be contacted regarding my feedback",
          hint: () => "We will use your contact details only to contact you regarding your feedback, not for marketing purposes."
        },
        contactMethod: {
          label: () => "Select contact method",
          options: {
            phone: () => "Phone call",
            email: () => "Email",
            web_message: () => "Message on OP's service"
          }
        },
        phone: {
          label: () => "Phone number",
          hint: () => "Type your phone number without space characters. If you have a foreign subscription, please enter your country code.",
          error: {
            empty: () => "Enter phone number.",
            invalid: () => "Check the phone number."
          }
        },
        email: {
          label: () => "Email address",
          error: {
            empty: () => "Enter email address.",
            invalid: () => "Check the email address."
          }
        },
        reachability: {
          label: () => "What is the best time to reach you?"
        },
        customerInfo: {
          label: () => "I want to leave my name and address so that my feedback can be processed faster"
        },
        name: {
          label: () => "Name",
          error: {
            empty: () => "Enter name.",
            invalid: () => "Check the name."
          }
        },
        moreInformation: {
          label: () => "more information"
        },
        address: {
          label: () => "Address",
          error: {
            empty: () => "Enter address.",
            invalid: () => "Check the address."
          }
        },
        postalCode: {
          label: () => "Postcode",
          error: {
            empty: () => "Enter postcode.",
            invalid: () => "Check the postcode."
          }
        },
        textArea: {
          error: {
            title: () => "Check spelling. ",
            text: () => "Permitted characters are Aa‒Öö, 0‒9 and special characters . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Permitted characters include lowercase and uppercase letters of the Finnish alphabet, digits from 0 to 9, and special characters including full stop, comma, colon, question mark, exclamation mark, apostrophe, quotation mark, plus sign, dash, ampersand, slash and brackets."
          }
        },
        send: () => "Send",
        error: {
          row1: () => "Sending failed.",
          row2: () => "Please try again."
        },
        quit: {
          button: () => "Quit",
          modal: {
            title: () => "Do you want to quit?",
            body: () => "If you quit, the information you provided will not be saved.",
            button: {
              quit: () => "Quit",
              cancel: () => "Cancel"
            }
          }
        }
      },
      sensitiveInfo: {
        identifiedCustomer: () => "Do not include any personal details in the description, such as a personal ID code, a user ID, card numbers or health information.",
        unidentifiedCustomer: () => "Do not include any personal details in the description, such as a personal ID code, a user ID, account numbers, card numbers or health information."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, en, { one: "Please check and correct the following item", other: "Please check and correct the following " + d.count + " items" })
      }
    },
    error: {
      title: () => "We are sorry, there is a disruption in our service",
      body: () => "Giving feedback is not possible temporarily. Please try again soon.",
      link: {
        form: () => "Please try again to give us feedback",
        frontpage: () => "Go to the op.fi homepage"
      }
    },
    quit: {
      title: () => "You stopped completing the form",
      body: () => "The information you entered was not saved.",
      link: {
        frontpage: () => "Go to the op.fi homepage",
        giveFeedback: () => "Go to the Give us feedback page"
      }
    },
    thanks: {
      title: () => "Thank you for your feedback!",
      body: () => "We are investigating your case and making every effort to solve it as soon as possible. We will contact you if you asked us to do so.",
      feedbackId: (d) => "For your record, your feedback ID: " + d.feedbackId + ".",
      link: () => "Go to the op.fi homepage"
    },
    url: {
      thanks: () => "/thanks-for-feedback",
      error: () => "/error",
      quit: () => "/aborted",
      opfi: {
        person: () => "",
        business: () => "/web/corp/auth/front-page",
        tupas: () => "",
        unidentified: () => ""
      },
      form: {
        person: () => "/private-customers/customer-service/report-a-problem",
        tupas: () => "/private-customers/customer-service/report-a-problem",
        unidentified: () => "/private-customers/customer-service/report-a-problem",
        business: () => "/web/corp/auth/customer-service/report-an-error"
      },
      giveFeedback: {
        person: () => "/private-customers/customer-service/feedback-and-problems",
        business: () => "/web/corp/auth/customer-service/feedback-and-problems",
        unidentified: () => "/private-customers/customer-service/feedback-and-problems",
        tupas: () => "/private-customers/customer-service/feedback-and-problems"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Do you want to continue using this service? ",
          text: () => "If you don’t want to continue but you already filled in some details, we will delete all such details to protect your security.",
          ok: () => "Continue using the service",
          cancel: () => "Quit using the service"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Your session was stopped",
          text: {
            a: () => "Because you were not actively using the service for a while, your session was stopped. If you had filled in some details, all such details were deleted to protect your security.",
            b: () => "If you had filled in some details, all such details were deleted to protect your security."
          },
          close: () => "Close"
        }
      }
    }
  },
  fi: {
    login: {
      body: () => "Palautteesi käsittely on sujuvampaa, jos kirjaudut ennen palautteen antamista.",
      link: () => "Kirjaudu palveluun ja ilmoita teknisestä ongelmasta"
    },
    info: {
      title: () => "Kuvaile ongelmaa mahdollisimman tarkkaan",
      list: {
        item1: () => "Mitä olit tekemässä, kun ongelma ilmeni? Mikä ei toiminut? Saitko virheilmoituksen? Jos, niin minkälaisen?",
        item2: () => "Olitko kirjautuneena OP:n tai jonkun toisen pankin tunnuksilla? Minkä pankin?",
        item3: () => "Ilmoita ongelman päivämäärä ja kellonaika sekä käyttämäsi laite (tietokone, tabletti, älypuhelin).",
        item4: {
          anonymous: () => "Jos mahdollista, ota ongelmasta kuvaruutukaappaus, sillä saatamme pyytää sitä sinulta myöhemmin. Jätä sitä varten yhteystietosi.",
          loggedIn: () => "Jos mahdollista, ota ongelmasta kuvaruutukaappaus, sillä saatamme pyytää sitä sinulta myöhemmin."
        }
      }
    },
    feedback: {
      header: () => "Ilmoitus teknisestä ongelmasta",
      body: () => "Kaikki kentät ovat pakollisia, ellei toisin mainita.",
      form: {
        optional: () => "(vapaaehtoinen)",
        target: {
          label: () => "Mitä asioita olit hoitamassa?",
          option: {
            "default": () => "- Valitse -",
            banking: () => "Pankkiasioita",
            insurance: () => "Vakuutusasioita",
            other: () => "Muita asioita"
          },
          error: {
            empty: () => "Valitse, mitä asioita olit hoitamassa."
          }
        },
        subject: {
          label: () => "Missä ongelma tapahtui?",
          option: {
            "default": () => "- Valitse -",
            report_issue_web_service: () => "Op.fi-verkkopalvelussa",
            report_issue_op_mobile: () => "OP-mobiilissa",
            report_issue_op_business_mobile: () => "OP-yritysmobiilissa"
          },
          error: {
            empty: () => "Valitse, missä ongelma tapahtui."
          }
        },
        text: {
          label: () => "Ongelman kuvaus",
          hint: () => "Kuvaile ongelmasi mahdollisimman tarkasti. Sivun alussa on listattu, mitkä tiedot ongelman selvittämiseksi tarvitaan.",
          error: {
            empty: () => "Kirjoita ongelman kuvaus."
          }
        },
        contactCustomer: {
          form: {
            label: () => "Yhteystiedot"
          },
          label: () => "Haluan, että minuun otetaan yhteyttä palautteeseeni liittyen",
          hint: () => "Käytämme yhteystietojasi vain palautteeseen liittyvään viestintään, emme markkinointiviestintään."
        },
        contactMethod: {
          label: () => "Valitse tapa",
          options: {
            phone: () => "Puhelinsoitto",
            email: () => "Sähköposti",
            web_message: () => "Viesti OP:n palvelussa"
          }
        },
        phone: {
          label: () => "Puhelinnumero",
          hint: () => "Kirjoita puhelinnumerosi ilman välilyöntejä. Jos liittymäsi on ulkomaalainen, muista maatunnus.",
          error: {
            empty: () => "Kirjoita puhelinnumero.",
            invalid: () => "Tarkista puhelinnumero."
          }
        },
        email: {
          label: () => "Sähköpostiosoite",
          error: {
            empty: () => "Kirjoita sähköpostiosoite.",
            invalid: () => "Tarkista sähköpostiosoite."
          }
        },
        reachability: {
          label: () => "Milloin olet parhaiten tavoitettavissa?"
        },
        customerInfo: {
          label: () => "Haluan jättää nimi- ja osoitetietoni, jotta palautteeni voidaan käsitellä sujuvammin"
        },
        name: {
          label: () => "Nimi",
          error: {
            empty: () => "Kirjoita nimi.",
            invalid: () => "Tarkista nimi."
          }
        },
        moreInformation: {
          label: () => "lisätietoja"
        },
        address: {
          label: () => "Osoite",
          error: {
            empty: () => "Kirjoita osoite.",
            invalid: () => "Tarkista osoite."
          }
        },
        postalCode: {
          label: () => "Postinumero",
          error: {
            empty: () => "Kirjoita postinumero.",
            invalid: () => "Tarkista postinumero."
          }
        },
        textArea: {
          error: {
            title: () => "Tarkista kirjoitusasu.",
            text: () => "Sallittuja merkkejä ovat kirjaimet Aa–Öö, numerot 0–9 ja erikoismerkit . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Sallittuja merkkejä ovat isot ja pienet kirjaimet a:sta ö:hön, numerot 0 viiva 9 ja erikoismerkit piste, pilkku, kaksoispiste, kysymysmerkki, huutomerkki, heittomerkki, lainausmerkki, plusmerkki, viiva, et-merkki, vinoviiva ja sulkeet."
          }
        },
        send: () => "Lähetä",
        error: {
          row1: () => "Lähetys ei onnistunut.",
          row2: () => "Ole hyvä ja yritä uudestaan."
        },
        quit: {
          button: () => "Keskeytä",
          modal: {
            title: () => "Haluatko keskeyttää?",
            body: () => "Jos keskeytät, antamiasi tietoja ei tallenneta.",
            button: {
              quit: () => "Keskeytä",
              cancel: () => "Peruuta"
            }
          }
        }
      },
      sensitiveInfo: {
        identifiedCustomer: () => "Älä kirjoita kuvaukseen henkilökohtaisia tietoja, kuten henkilötunnusta, käyttäjätunnuksia, korttien numeroita tai terveystietoja.",
        unidentifiedCustomer: () => "Älä kirjoita kuvaukseen henkilökohtaisia tietoja, kuten henkilötunnusta, käyttäjätunnuksia, tilinumeroita, korttien numeroita tai terveystietoja."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, fi, { one: "Tarkista ja korjaa seuraava kohta", other: "Tarkista ja korjaa seuraavat " + d.count + " kohtaa" })
      }
    },
    error: {
      title: () => "Häiriö palvelussa, pahoittelemme",
      body: () => "Palautteen antaminen ei juuri nyt onnistu. Ole hyvä ja yritä kohta uudestaan.",
      link: {
        form: () => "Yritä palautteen antamista uudestaan",
        frontpage: () => "Siirry op.fi:n etusivulle"
      }
    },
    quit: {
      title: () => "Keskeytit lomakkeen täyttämisen",
      body: () => "Antamiasi tietoja ei tallennettu palveluun.",
      link: {
        frontpage: () => "Siirry op.fi:n etusivulle",
        giveFeedback: () => "Siirry Anna palautetta -sivulle"
      }
    },
    thanks: {
      title: () => "Kiitos palautteestasi!",
      body: () => "Selvitämme asiaasi ja pyrimme ratkaisemaan sen mahdollisimman pian. Otamme sinuun yhteyttä, jos toivoit sitä.",
      feedbackId: (d) => "Halutessasi voit ottaa talteen palautteen numeron: " + d.feedbackId + ".",
      link: () => "Siirry op.fi:n etusivulle"
    },
    url: {
      thanks: () => "/kiitos-palautteestasi",
      error: () => "/virhe",
      quit: () => "/keskeytetty",
      opfi: {
        person: () => "/auth/paivittaiset",
        business: () => "/web/corp/auth/etusivu",
        tupas: () => "/auth/paivittaiset",
        unidentified: () => ""
      },
      form: {
        person: () => "/auth/asiakaspalvelu/ilmoita-ongelmasta",
        tupas: () => "/auth/asiakaspalvelu/ilmoita-ongelmasta",
        unidentified: () => "/henkiloasiakkaat/asiakaspalvelu/ilmoita-ongelmasta",
        business: () => "/web/corp/auth/asiakaspalvelu/ilmoita-ongelmasta"
      },
      giveFeedback: {
        person: () => "/auth/asiakaspalvelu/palautteet-ja-ongelmat",
        business: () => "/web/corp/auth/asiakaspalvelu/palautteet-ja-ongelmat",
        unidentified: () => "/henkiloasiakkaat/asiakaspalvelu/palautteet-ja-ongelmat",
        tupas: () => "/auth/asiakaspalvelu/palautteet-ja-ongelmat"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Haluatko jatkaa asiointia?",
          text: () => "Jos et jatka asiointia ja ehdit täyttää jotain tietoja, poistamme kaikki tiedot oman turvallisuutesi vuoksi.",
          ok: () => "Jatka asiointia",
          cancel: () => "Keskeytä asiointi"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Asiointi keskeytetty",
          text: {
            a: () => "Koska et hetkeen käyttänyt palvelua, asiointisi keskeytettiin. Jos olit täyttänyt jotain tietoja, kaikki tiedot poistettiin oman turvallisuutesi vuoksi.",
            b: () => "Jos olit täyttänyt jotain tietoja, kaikki tiedot poistettiin oman turvallisuutesi vuoksi."
          },
          close: () => "Sulje"
        }
      }
    }
  },
  sv: {
    login: {
      body: () => "Behandlingen av din respons går smidigare om du loggar in innan du ger respons.",
      link: () => "Logga in i tjänsten och anmäl ett tekniskt fel"
    },
    info: {
      title: () => "Beskriv problemet så noggrant som möjligt",
      list: {
        item1: () => "Vad höll du på att göra då problemet uppstod? Vad fungerade inte? Fick du ett felmeddelande? I så fall, hurdant?",
        item2: () => "Var du inloggad med OP:s eller någon annan banks koder? Vilken banks?",
        item3: () => "Meddela datum och klockslag för problemet samt vilken apparat du använde (dator, datorplatta, smarttelefon).",
        item4: {
          anonymous: () => "Ta en skärmbild av problemet om det är möjligt, eftersom vi senare kan be dig om den. Lämna därför din kontaktinformation.",
          loggedIn: () => "Ta en skärmbild av problemet om det är möjligt, eftersom vi senare kan be dig om den."
        }
      }
    },
    feedback: {
      header: () => "Anmälan om ett tekniskt fel",
      body: () => "Alla punkter är obligatoriska, om inget annat anges.",
      form: {
        optional: () => "(frivillig)",
        target: {
          label: () => "Vad skötte du för ärenden?",
          option: {
            "default": () => "- Välj -",
            banking: () => "Bankärenden",
            insurance: () => "Försäkringsärenden",
            other: () => "Andra ärenden"
          },
          error: {
            empty: () => "Välj vilket slags ärenden du skötte."
          }
        },
        subject: {
          label: () => "Var inträffade problemet?",
          option: {
            "default": () => "- Välj -",
            report_issue_web_service: () => "Nättjänsten op.fi",
            report_issue_op_mobile: () => "OP-mobilen",
            report_issue_op_business_mobile: () => "OP-företagsmobilen"
          },
          error: {
            empty: () => "Välj var problemet inträffade."
          }
        },
        text: {
          label: () => "Beskrivning av problemet",
          hint: () => "Beskriv ditt problem så noggrant som möjligt. I början av sidan finns en uppräkning av vad som behövs för att reda ut problemet.",
          error: {
            empty: () => "Beskriv problemet."
          }
        },
        contactCustomer: {
          form: {
            label: () => "Kontaktuppgifter"
          },
          label: () => "Jag vill bli kontaktad gällande min respons",
          hint: () => "Vi använder din kontaktinformation endast för kommunikation i anslutning till responsen, inte för marknadsföring."
        },
        contactMethod: {
          label: () => "Välj kontaktsätt",
          options: {
            phone: () => "Per telefon",
            email: () => "Per e-post",
            web_message: () => "Meddelande via OP:s tjänst"
          }
        },
        phone: {
          label: () => "Telefonnummer",
          hint: () => "Skriv ditt telefonnummer utan mellanslag. Kom ihåg landskoden, om du har ett utländskt abonnemang.",
          error: {
            empty: () => "Skriv telefonnumret.",
            invalid: () => "Kontrollera telefonnumret."
          }
        },
        email: {
          label: () => "E-postadress",
          error: {
            empty: () => "Skriv e-postadressen.",
            invalid: () => "Kontrollera e-postadressen."
          }
        },
        reachability: {
          label: () => "När är du bäst anträffbar?"
        },
        moreInformation: {
          label: () => "tilläggsuppgifter"
        },
        customerInfo: {
          label: () => "Jag vill lämna mina namn- och adressuppgifter för att min respons ska kunna behandlas smidigare"
        },
        name: {
          label: () => "Namn",
          error: {
            empty: () => "Skriv namnet.",
            invalid: () => "Kontrollera namnet."
          }
        },
        address: {
          label: () => "Adress",
          error: {
            empty: () => "Skriv adressen.",
            invalid: () => "Kontrollera adressen."
          }
        },
        postalCode: {
          label: () => "Postnummer",
          error: {
            empty: () => "Skriv postnumret.",
            invalid: () => "Kontrollera postnumret."
          }
        },
        textArea: {
          error: {
            title: () => "Kontrollera stavningen. ",
            text: () => "Tillåtna tecken är bokstäverna Aa–Öö, siffrorna 0–9 och specialtecknen . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Tillåtna tecken är de stora och små bokstäverna från a till ö, siffrorna från 0 till 9 och specialtecknen punkt, komma, kolon, frågetecken, utropstecken, apostrof, citattecken, plustecken, streck, et-tecken, snedstreck och parentes."
          }
        },
        send: () => "Sänd",
        error: {
          row1: () => "Sändningen lyckades inte.",
          row2: () => "Var god och försök på nytt."
        },
        quit: {
          button: () => "Avbryt",
          modal: {
            title: () => "Vill du avbryta?",
            body: () => "Om du avbryter, sparas inte de uppgifter som du gett.",
            button: {
              quit: () => "Avbryt",
              cancel: () => "Tillbaka"
            }
          }
        }
      },
      sensitiveInfo: {
        identifiedCustomer: () => "Skriv inte personliga uppgifter i beskrivningen. Sådana är till exempel personbeteckning, användarkoder, kortnummer och hälsouppgifter.",
        unidentifiedCustomer: () => "Skriv inte personliga uppgifter i beskrivningen. Sådana är till exempel personbeteckning, användarkoder, kontonummer, kortnummer och hälsouppgifter."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, sv, { one: "Kontrollera och rätta följande fält", other: "Kontrollera och rätta följande " + d.count + " fält" })
      }
    },
    error: {
      title: () => "Störning i tjänsten, vi beklagar",
      body: () => "De går inte att ge respons just nu. Försök på nytt om en stund.",
      link: {
        form: () => "Försök ge respons på nytt",
        frontpage: () => "Gå till ingångssidan för op.fi"
      }
    },
    quit: {
      title: () => "Du avbröt ifyllningen av blanketten",
      body: () => "De uppgifter som du angett har inte sparats.",
      link: {
        frontpage: () => "Gå till ingångssidan för op.fi",
        giveFeedback: () => "Gå till sidan Ge respons"
      }
    },
    thanks: {
      title: () => "Tack för din respons!",
      body: () => "Vi reder ut ärendet och försöker lösa det så fort som möjligt. Vi kontaktar dig om du har önskat det.",
      feedbackId: (d) => "Om du vill kan du spara numret på responsen: " + d.feedbackId + ".",
      link: () => "Gå till ingångssidan för op.fi"
    },
    url: {
      thanks: () => "/tack-for-aterkoppling",
      error: () => "/fel",
      quit: () => "/avbruten",
      opfi: {
        person: () => "/auth/dagliga-penningaffarer",
        business: () => "/web/corp/auth/ingangssidan",
        tupas: () => "/auth/dagliga-penningaffarer",
        unidentified: () => ""
      },
      form: {
        person: () => "/auth/kundtjanst/anmal-problem",
        tupas: () => "/auth/kundtjanst/anmal-problem",
        unidentified: () => "/privatkunder/kundtjanst/anmal-problem",
        business: () => "/web/corp/auth/kundtjanst/anmal-problem"
      },
      giveFeedback: {
        person: () => "/auth/kundtjanst/respons-och-problem",
        business: () => "/web/corp/auth/kundtjanst/respons-och-problem",
        unidentified: () => "/privatkunder/kundtjanst/respons-och-problem",
        tupas: () => "/auth/kundtjanst/respons-och-problem"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Vill du fortsätta använda tjänsten?",
          text: () => "Om du inte vill fortsätta men redan hann fylla i uppgifter, raderar vi av säkerhetsskäl alla uppgifter.",
          ok: () => "Fortsätt använda tjänsten",
          cancel: () => "Sluta använda tjänsten"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Sessionen avbröts",
          text: {
            a: () => "Eftersom du inte använt tjänsten på en stund, avbröts din session. Om du hade fyllt i uppgifter, raderades alla uppgifter av säkerhetsskäl.",
            b: () => "Om du hade fyllt i uppgifter, raderades alla uppgifter av säkerhetsskäl."
          },
          close: () => "Stäng"
        }
      }
    }
  }
}